import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoEmptyState } from "@disco-ui"
import React from "react"

type props = {
  title?: string
  subtitle?: string
  buttons?: React.ReactNode
  icon?: React.ReactNode
  testid?: string
}

function DashboardBlockEmptyState(props: props) {
  const classes = useStyles()

  return (
    <DiscoEmptyState
      className={classes.emptyState}
      icon={props.icon}
      testid={props.testid ?? `DashboardBlockEmptyState.${props.title}`}
      title={props.title}
      subtitle={props.subtitle}
      variant={"dashboard"}
      buttons={props.buttons}
    />
  )
}
const useStyles = makeUseStyles((theme) => ({
  emptyState: {
    width: "100%",
    border: `1px solid ${theme.palette.groovy.neutral[200]}`,
    borderRadius: theme.measure.borderRadius.big,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.palette.groovyDepths.xs,
    color: theme.palette.text.primary,
    height: "203px",
    padding: theme.spacing(2),
  },
}))

export default DashboardBlockEmptyState
